import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import DateDisplay from "components/datetime/DateDisplay";
import ConditionalRender from "components/ConditionalRender";

const TableBridgeMeasures = (props) => {
    const {t} = useTranslation("tables");

    // Verificar si items es un array
    if (!Array.isArray(props.items)) {
        return <div className="alert alert-secondary text-center">{t("common.noData")}</div>;
    }

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    const makeSearch = (filters) => {
        const params = new URLSearchParams();
        if (filters && typeof filters === "object") {
            Object.entries(filters).forEach(([k, v]) => {
                if (v !== undefined && v !== null && v !== "") {
                    params.append(k, v);
                }
            });
        }
        const s = params.toString();
        return s ? `?${s}` : "";
    };

    return (
        <div className="col-12">
            <table className="table table-striped table-sticky-horizontal">
                <thead>
                    <tr>
                        <th style={{width: "160px", ...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                            {t("containers.UID")}
                        </th>
                        <th style={{width: "160px", ...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                            {t("containers.UUID")}
                        </th>
                        <th style={{width: "160px", ...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                            {t("containers.TAG")}
                        </th>
                        <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                            {t("labels.measure")}
                        </th>
                        <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                            {t("containers.last_communication")}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {props.items.map((item, index) => (
                        <tr key={index} data-idx={index}>
                            <td>
                                <Link
                                    to={`/historic/measures/${item.uid}/`}
                                    className="text-dark"
                                    style={{textDecoration: "none"}}>
                                    <strong>{item.uid}</strong>
                                </Link>
                            </td>
                            <td>{item.uuids}</td>
                            <td>{item.tag}</td>
                            <td>{item.measure}</td>
                            <td>
                                <ConditionalRender condition={item.last_comm_at} fallback={<span>-</span>}>
                                    <DateDisplay date={item.last_comm_at} format="DD-MM-YYYY HH:mm" title={true} />
                                </ConditionalRender>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableBridgeMeasures;
